module.exports = __webpack_public_path__ + "img/Z71_09.b66a54bb.jpg";